import React from "react";
import "./separator.scss";
const ShimmerSeparator = () => <div className="shimmer-separator"></div>;

export default ShimmerSeparator;
